module.exports=function(scope){ return `String licenseKeyIdentifier = "<THIS_IDENTIFIER_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT>";

// Key text is an extra required paramter for SFTP Log mode only.
// This MUST BE the EXACT text from your Key.  If you modify the text, Key validation will fail.
// If copied from a Key file, make sure Key text is a single string with newLine ('\\n') characters where appropriate.
// 'appId' should match your application's unique applicationId.
String licenseText =
    "appId      = <THIS_APPID(s)_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>\\n" +
    "expiryDate = <THIS_DATE_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>\\n" +
    "key        = <THIS_KEY_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>\\n";

// Initialize ZoomSDK using a Device SDK Key - SFTP Log mode
// @param - context - The current activity that's launching the User Session
// @param - licenseText - This is the contents of the actual Key file that FaceTec generated for you. Your Key (s) can be downloaded here -- https://dev.facetec.com/zoomsdk/#/account
// @param - licenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - ZoomSDK.InitializeCallback -  Optional callback to notify caller when FaceTec SDK initialization has completed
//
ZoomSDK.initializeWithLicense(context, licenseText, licenseKeyIdentifier, new ZoomSDK.InitializeCallback() {
    @Override
    public void onCompletion(boolean successful) {
        if(!successful) {
            handleUnsuccessfulInit();
            return;
        }

        // Ready to launch the User Session!
    }
});
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/android/00-initialize-prod.java.tpl